import { Controller } from 'stimulus'

// The Sample Disposition built-in on job forms: four radio cards and a
// Disposition Note. Highlights the chosen card, and makes the note required
// while "Other" is chosen (the server checks it too, see Job).
export default class extends Controller {
  static targets = ['choice', 'note', 'noteOptional', 'noteRequired']

  connect() {
    this.change()
  }

  change() {
    let other = false

    this.choiceTargets.forEach((choice) => {
      const radio = choice.querySelector('input[type="radio"]')
      const checked = radio && radio.checked
      choice.classList.toggle('border-blue-500', checked)
      choice.classList.toggle('bg-blue-50', checked)
      choice.classList.toggle('border-gray-300', !checked)
      choice.classList.toggle('bg-white', !checked)
      if (checked && radio.value === 'other') other = true
    })

    if (this.hasNoteTarget) this.noteTarget.required = other
    if (this.hasNoteOptionalTarget) this.noteOptionalTarget.classList.toggle('hidden', other)
    if (this.hasNoteRequiredTarget) this.noteRequiredTarget.classList.toggle('hidden', !other)
  }
}
